module.exports = __webpack_public_path__ + "img/map1.5832cada.png";